<template>
    <div>
        <v-dialog :model-value="deleteItem" @update:model-value="close" max-width="420px" persistent>
            <v-card class="rounded-lg">
              <v-card-title class="bg-primary">
                Confirmar exclusão
              </v-card-title>
              <v-card-text class="text-body-1 text-md-center pa-4 ma-4">
                <v-icon icon="mdi-alert" size="large"></v-icon> Tem certeza que deseja
                excluir esse item?
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="bg-secondary d-flex justify-center">
                <v-btn color="blue-darken-1" variant="outlined" @click="this.close()">
                  Cancelar
                </v-btn>
                <v-btn color="primary" variant="tonal" @click="deleteItemConfirm(url, deleteId)">
                  Excluir
                </v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    props: {
        url: {
            type: String,
            default: null
        },
        deleteItem: {
            type: Boolean,
            default: null
        },
        deleteId: {
            type: Number,
            default: null
        }
    },
    methods: {
        deleteItemConfirm(url, id) {
            this.$axios.delete(url + id)
                .then(response => {
                    console.log(response.data);
                    this.close();
                    window.location.reload();
                })
                .catch(error => {
                    console.error('Erro na requisição Delete:', error);
                })
        },
        close() {
            this.$emit('update:deleteItem', false);
        },
    },  
}
</script>